export default {
  'message.loginSuccess': '登录成功',
  'message.geetestCaptchaError': '请先等待极验验证码加载完成',
  'message.getCaptchaSuccess': '获取验证码成功',
  'message.getCaptchaError': '获取验证码失败',
  'message.deleteConfirm': '确定删除吗？',
  'message.addSuccess': '新增成功',
  'message.editSuccess': '编辑成功',
  'message.deleteSuccess': '删除成功',
  'message.resetSuccess': '重置成功',
  'message.assignSuccess': '分配成功',
  'message.operationSuccess': '操作成功',
  'message.operationError': '操作失败',
  'message.passwordError': '两次密码不一致',
  'message.selectMenu': '请选择菜单权限',
  'message.selectDept': '请选择数据权限部门',
  'message.googleBindSuccess': '谷歌验证器绑定成功',
  'message.googleBindError': '谷歌验证器绑定失败',
  'message.googleUnbindSuccess': '谷歌验证器解绑成功',
  'message.googleUnbindError': '谷歌验证器解绑失败',
  'message.loginExpired': '登录已过期，请重新登录',
  'message.networkError': '网络请求失败，请稍后重试',
  'message.changeSuccess': '切换成功',
  'message.noPermission': '您没有权限进行此操作',
  'message.transferSuccess': '转移成功',
  'message.transferChildError': '不能将节点拖拽为其自身的子节点',
  'message.updateError': '更新失败',
  'message.loading': '加载中...',
  'message.noData': '暂无数据',
  'message.transferError': '转移失败',
  'message.getUserDataError': '获取用户数据失败',
  'message.copySuccess': '复制成功',
  'message.copyError': '复制失败',
  'message.operationFailed': '操作失败',
  'message.levelReturnScaleError': '级别 {levelIndex} 的返佣比例必须小于级别 {levelIndex2} 的返佣比例',
  'message.levelReturnScaleError1': '至少保留一个级别',
  'message.levelReturnScaleError2': '请输入级别 {levelIndex} 的返佣比例',
  'message.commissionChangeConfirm': '参与返佣提示',
  'message.commissionChangeConfirmOperation': '请确认是否要对UID为{uid}开启参与返佣操作，开启后将获得佣金返佣收益。',
  'message.commissionChangeConfirmOperationCancel':
    '请确认是否要对UID为{uid}关闭参与返佣操作，关闭后将无法获得佣金返佣收益。',
  'message.passwordUpdateSuccess': '密码更新成功',
  'message.noSearchUser': '未搜索到用户，请确认UID输入是否正确',
  'message.actualCommissionBenefit': '实际佣金收益数量以已结算的数量为准',
  'message.exportSuccess': '导出成功',
  'message.exportError': '导出失败',
  'message.cancelPartnerConfirm': '请确认是否要取消该用户的合伙人：UID {uid}',
  'message.cancelPartnerConfirm2': '取消后将不会再获得返佣和登录合伙人平台系统',
  'message.cancelPartnerConfirmTip': '取消合伙人提示',
  'message.statusChangeEnableTip': '启用提示',
  'message.statusChangeDisableTip': '停用提示',
  'message.statusChangeDisableOperation':
    '请问是否确认停用该邀请链接配置，停用后新用户无法通过链接进行注册绑定好友关系，已注册的用户不受影响。请谨慎操作！',
  'message.statusChangeEnableOperation':
    '请问是否确认启用该邀请链接配置，启用后新用户可以通过链接进行注册绑定好友关系，已注册的用户不受影响。请谨慎操作！',
  'message.statusDeleteOperation': '该链路注册人数不为0，无法删除！',
  'message.statusDeleteDisableOperation': '该链路状态为启用中，如需删除请先操作停用才可进行删除！',
  'message.pleaseSelectEnter': '请选择或输入',
  'message.timeRangeCannotExceedDays': '查询时间范围不能超过31天',
  'message.emailInvalid': '请输入有效的邮箱地址',
  'message.emailMustBe': '请输入有效的邮箱地址（必须以@bitbaby.com结尾）',
  'message.telegramInvalid': '请输入有效的Telegram账号',
  'message.twitterInvalid': '请输入有效的Twitter账号',
  'message.discordInvalid': '请输入有效的Discord账号',
  'message.contentCannotBeEmpty': '内容不能为空',
  'message.selfRebateScaleRequired': '请输入自返佣比例',
  'message.futuresSelfRebateScaleRequired': '请输入合约自返佣比例',
  'message.spotSelfRebateScaleRequired': '请输入现货自返佣比例',
  'message.selfRebateScaleExceedsFutures': '合约自返佣比例不能大于合约返佣比例',
  'message.selfRebateScaleExceedsSpot': '现货自返佣比例不能大于一级返佣比例',
};
